<script setup lang="ts">
const props = defineProps<{
  class?: string
}>()
</script>

<template>
  <div class="form-wrapper" :class="props.class">
    <ErrorMessage name="baseError">
      <template #default="{ message }">
        <div class="callout error stretch">{{ message }}</div>
      </template>
    </ErrorMessage>
    <slot />
  </div>
</template>
